export enum RootMutations {
  ShowToaster = 'showToaster',
  ShowEternalToaster = 'showEternalToaster',
  RemoveToaster = 'removeToaster',
  RemoveToasters = 'removeToasters',
  ShowSpinner = 'showSpinner',
  RemoveSpinner = 'removeSpinner',
  EnableVendonSpinner = 'enableVendonSpinner',
  DisableVendonSpinner = 'disableVendonSpinner',
}

export enum RootActions {
  ShowToaster = 'showToaster',
  ShowEternalToaster = 'showEternalToaster',
  ShowSpinner = 'showSpinner',
  RemoveSpinner = 'removeSpinner',
  RemoveToaster = 'removeToaster',
  RemoveToasters = 'removeToasters',
  EnableVendonSpinner = 'enableVendonSpinner',
  DisableVendonSpinner = 'disableVendonSpinner',
}

export enum RootGetters {
  Toasters = 'toasters',
  Spinners = 'spinners',
  VendonSpinner = 'vendonSpinner',
}

export enum DashboardActions {
  DashboardView = 0,
  DeleteAccount = 1,
  EditAccount = 2,
  PurchaseHistory = 3,
  Feedback = 4,
  OnlineRecharge = 5,
}
